"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _Preview = _interopRequireDefault(require("./Preview.js"));
var _reactRedux = require("react-redux");
var _builder = require("../../../reducers/builder.js");
var _builder2 = require("../../../selectors/builder.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Component = /*#__PURE__*/function (_React$Component) {
  _inherits(Component, _React$Component);
  function Component() {
    var _this;
    _classCallCheck(this, Component);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Component, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "getSizes", function () {
      return [{
        name: 'mobile',
        title: 'Mobile',
        style: {
          width: 'auto',
          maxWidth: '375px'
        }
      }, {
        name: 'tablet',
        title: 'Tablet',
        style: {
          width: 'auto',
          maxWidth: '790px'
        }
      }, {
        name: 'desktop',
        title: 'Desktop',
        style: {
          width: 'auto',
          maxWidth: '1024px'
        }
      }];
    });
    _defineProperty(_assertThisInitialized(_this), "renderResponsiveButtons", function () {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].responsiveButtons
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group btn-group-sm"
      }, _this.getSizes().map(function (o) {
        return /*#__PURE__*/_react["default"].createElement("a", {
          key: o.name,
          className: "btn btn-secondary ".concat(o.name === _this.props.previewSize && 'active'),
          onClick: _this.props.changePreviewSize.bind(_assertThisInitialized(_this), o.name)
        }, o.title);
      })));
    });
    return _this;
  }
  _createClass(Component, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var currentSize = this.getSizes().find(function (o) {
        return o.name === _this2.props.previewSize;
      });
      return /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        trigger: this.props.trigger,
        title: /*#__PURE__*/_react["default"].createElement("div", null, this.props.title, this.renderResponsiveButtons()),
        contentStyle: currentSize.style,
        bodyStyle: {
          background: 'radial-gradient(ellipse, #fff 40%, #f0f0f0 100%)',
          zIndex: 3
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        "data-cccisd-survey-area": true
      }, /*#__PURE__*/_react["default"].createElement(_Preview["default"], {
        parentId: this.props.parentId,
        list: this.props.list,
        settings: this.props.settings
      })));
    }
  }]);
  return Component;
}(_react["default"].Component);
_defineProperty(Component, "propTypes", {
  trigger: _propTypes["default"].node,
  parentId: _propTypes["default"].number,
  title: _propTypes["default"].string,
  previewSize: _propTypes["default"].string,
  changePreviewSize: _propTypes["default"].func,
  list: _propTypes["default"].object.isRequired,
  settings: _propTypes["default"].object.isRequired
});
_defineProperty(Component, "defaultProps", {
  trigger: /*#__PURE__*/_react["default"].createElement("a", {
    className: "btn btn-secondary btn-sm"
  }, "Preview"),
  title: 'Preview'
});
var mapStateToProps = function mapStateToProps(state) {
  return {
    list: (0, _builder2.getListForPreview)(state.flow.builder),
    settings: state.flow.builder.settings,
    previewSize: state.flow.builder.previewSize
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  changePreviewSize: _builder.changePreviewSize
})(Component);